import React, {Component} from 'react';
import Relay from 'react-relay';
import cookie from '../../helper/cookie'

import Sidebar from '../../components/Sidebar';
import AllCustomersORAgents from './allcustomersOrAgents'

class AllCustomers_agents_page extends Component{
  
  constructor(props){
    super(props);
    var data = [];
    this.props.viewer.allCustomers.map((object, index) => {
      
      var conversationData = [];
      object.conversations.map((edge, node) => {
        
        var date = new Date(edge.startDate);
        date = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
        
        var agentPicture,agentName;
        if (edge.agent == null){
          agentPicture="http://dndw32r4edmw5.cloudfront.net/avatar/Male.png",
          agentName="Not Assigned"
        }
        else{
          agentPicture=edge.agent.picture,
          agentName=edge.agent.name
        }
        conversationData.push({
          id: edge.pid,
          projectname: edge.name,
          agentimg:agentPicture,
          agentname: agentName,
          status: edge.status,
          dos: date,
          lastactivity:"2:46 pm"
        })
      });
      
      data.push({
        customername:object.email.split("@")[0],
        customerimg:object.picture,
        firstactivity:"Yesterday",
        lastactivity:"8:46 pm",
        projectdata: conversationData
      });

    });
    this.state={allcustomers:data};
  }

  render()
  {
    if (cookie.get('access_token') != null) {
    return (
        <div>
          <div className="row">
            <div className="col-md-1 col-sm-1">
              <div className="col-md-12" style={{backgroundColor:"#e5e5e5",height:"100%"}}>
              <Sidebar source="customers"/>
              </div>
            </div>
            <div className="col-md-10 col-sm-11" id='root'>
                <AllCustomersORAgents dataArray={this.state.allcustomers} customer="true" />
            </div>
          </div>
        </div>

    );
     }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

export default Relay.createContainer(AllCustomers_agents_page, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Agent {
        allCustomers {
          pid
          email
          picture
          type
          conversations {
            pid
            name
            agent {
              name
              picture
            }
            status
            startDate
          }
        }
      }
    `
  }
});


/** WEBPACK FOOTER **
 ** ./src/views/AllCustomer/index.js
 **/